<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="模板代码" prop="businesscode">
      <el-input v-model="dataForm.businesscode" placeholder="模板代码"></el-input>
    </el-form-item>
    <el-form-item label="模板名称" prop="name">
      <el-input v-model="dataForm.name" placeholder="模板名称"></el-input>
    </el-form-item>
    <el-form-item label="租户" prop="tenant">
      <el-select 
        filterable 
        v-model="dataForm.tenant" 
        clearable 
        placeholder="请选择" 
        style="width: 100%">
        <el-option 
          v-for="item in initValue.tenantlist" 
          :key="item.id" 
          :label="item.name" 
          :value="item.code">
        </el-option>
      </el-select>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
      </el-button>
      <el-button type="primary" @click="dataFormSubmit()">
        <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        initValue: {
          tenantlist: []
        },
        visible: false,
        dataForm: {
          mailtemplateId: 0,
          businesscode: '',
          documentname: '',
          encryptionName: '',
          saveAdd: '',
          documentSize: '',
          uploader: '',
          uploadTime: '',
          name:'',
          describe: '',
          tenant: '',
          createdBy: '',
          createDate: '',
          updatedBy: '',
          updateDate: '',
          deletedBy: '',
          deleteDate: '',
          isDeleted: '',
          remark: '',
          optCounter: ''
        },
        dataRule: {
          businesscode: [
            { required: true, message: '业务ID不能为空', trigger: 'blur' }
          ],
          documentname: [
            { required: true, message: '文档名称不能为空', trigger: 'blur' }
          ],
          encryptionName: [
            { required: true, message: '加密后文档名称不能为空', trigger: 'blur' }
          ],
          saveAdd: [
            { required: true, message: '保存地址不能为空', trigger: 'blur' }
          ],
          documentSize: [
            { required: true, message: '文档大小(字节)不能为空', trigger: 'blur' }
          ],
          uploader: [
            { required: true, message: '上传者不能为空', trigger: 'blur' }
          ],
          uploadTime: [
            { required: true, message: '上传时间不能为空', trigger: 'blur' }
          ],
          describe: [
            { required: true, message: '描述不能为空', trigger: 'blur' }
          ],
          tenant: [
            { required: true, message: '租户不能为空', trigger: 'blur' }
          ],
          createdBy: [
            { required: true, message: '创建人不能为空', trigger: 'blur' }
          ],
          createDate: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          updatedBy: [
            { required: true, message: '修改人不能为空', trigger: 'blur' }
          ],
          updateDate: [
            { required: true, message: '修改时间不能为空', trigger: 'blur' }
          ],
          deletedBy: [
            { required: true, message: '删除人不能为空', trigger: 'blur' }
          ],
          deleteDate: [
            { required: true, message: '删除日期不能为空', trigger: 'blur' }
          ],
          isDeleted: [
            { required: true, message: '删除标识:‘0’未删除；‘1’已删除不能为空', trigger: 'blur' }
          ],
          remark: [
            { required: true, message: '备注不能为空', trigger: 'blur' }
          ],
          optCounter: [
            { required: true, message: '版本号不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.mailtemplateId = id || 0
        this.visible = true
        // 设置租户数据
        this.$getAllTenants((data) => {
          this.initValue.tenantlist = data
        })        
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.mailtemplateId) {
            this.$http({
              url: this.$http.adornUrl(`/sys/template/info/${this.dataForm.mailtemplateId}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.businesscode = data.template.businesscode
                this.dataForm.documentname = data.template.documentname
                this.dataForm.encryptionName = data.template.encryptionName
                this.dataForm.saveAdd = data.template.saveAdd
                this.dataForm.documentSize = data.template.documentSize
                this.dataForm.uploader = data.template.uploader
                this.dataForm.uploadTime = data.template.uploadTime
                this.dataForm.describe = data.template.describe
                this.dataForm.tenant = data.template.tenant
                this.dataForm.createdBy = data.template.createdBy
                this.dataForm.createDate = data.template.createDate
                this.dataForm.updatedBy = data.template.updatedBy
                this.dataForm.updateDate = data.template.updateDate
                this.dataForm.deletedBy = data.template.deletedBy
                this.dataForm.deleteDate = data.template.deleteDate
                this.dataForm.isDeleted = data.template.isDeleted
                this.dataForm.remark = data.template.remark
                this.dataForm.name = data.template.name
                this.dataForm.optCounter = data.template.optCounter
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/sys/template/${!this.dataForm.mailtemplateId ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'mailtemplateId': this.dataForm.mailtemplateId || undefined,
                'businesscode': this.dataForm.businesscode,
                'documentname': this.dataForm.documentname,
                'encryptionName': this.dataForm.encryptionName,
                'saveAdd': this.dataForm.saveAdd,
                'documentSize': this.dataForm.documentSize,
                'uploader': this.dataForm.uploader,
                'uploadTime': this.dataForm.uploadTime,
                'describe': this.dataForm.describe,
                'tenant': this.dataForm.tenant,
                'createdBy': this.dataForm.createdBy,
                'createDate': this.dataForm.createDate,
                'updatedBy': this.dataForm.updatedBy,
                'updateDate': this.dataForm.updateDate,
                'deletedBy': this.dataForm.deletedBy,
                'deleteDate': this.dataForm.deleteDate,
                'isDeleted': this.dataForm.isDeleted,
                'remark': this.dataForm.remark,
                'name': this.dataForm.name,
                'optCounter': this.dataForm.optCounter
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
